// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"9aedc3e5","703":"f2c60403"}[chunkId] + ".chunk.js";
};